<template>
    <div class="hris-page">
        <div class="hris-page-inner">
        <div class="hris-page-header">
            <span class="hris-page-eyebrow">Communications</span>
            <h1 class="hris-page-title">Announcements</h1>
            <p class="hris-page-subtitle">Company updates and notices.</p>
        </div>

        <div v-if="!pub || pub.length === 0" class="hris-empty hris-panel">
            No announcements available.
        </div>

        <div v-else class="hris-grid">
            <div
                class="hris-content-card"
                v-for="item in pub"
                :key="item.id"
            >
                <div class="hris-content-card-body">
                    <div class="row items-start justify-between no-wrap" style="gap: 8px;">
                        <h3 class="hris-content-card-title" style="flex: 1; min-width: 0;">
                            {{ item.subject }}
                        </h3>
                        <span
                            v-show="item.status == 'new'"
                            class="hris-badge hris-badge-accent caps"
                        >new</span>
                    </div>
                    <div class="hris-content-card-meta">
                        by {{ item.created_by }} · <span v-html="item.timeAgo"></span>
                    </div>
                    <div
                        class="hris-content-card-text"
                        v-if="item.full_message != ''"
                        v-html="item.message"
                        @click="readMoreModal(item)"
                        style="cursor: pointer;"
                    ></div>
                    <div
                        class="hris-content-card-text"
                        v-else
                        v-html="item.message"
                    ></div>
                </div>
                <div class="hris-content-card-footer">
                    <q-btn
                        flat
                        dense
                        unelevated
                        class="hris-q-ghost"
                        @click="dlAttacment(item.attachmentLink, item.attachment)"
                    >
                        <i class="fa fa-paperclip" style="margin-right: 6px;"></i>
                        Download Attachment
                    </q-btn>
                </div>
            </div>
        </div>

        <ReadMoreModal></ReadMoreModal>
        </div>
    </div>
</template>

<script>
	import axios from 'axios';
	import mixins from '../../mixins';
	import ReadMoreModal from './AdminReadMore';

	export default {
		components:{
			"ReadMoreModal": ReadMoreModal,
		},

		data() {
			return {
				data:[],
				message: "hello world",
				showMessage: true,
				deleteDialog: false,
				publishModel: [],
				id: '',
				isPub:'',
				fullMsg: '',
				pub: [],
				nPub: []

			}
		},

		created(){
			this.eventHub.$on('readMoreAnnouncement', this.displayData);
			this.displayData();
		},

		methods: {
			displayData: function(){
				axios.create({
				baseURL: this.apiUrl,
				headers: {
					'Authorization': `Bearer ${this.token}`
				}})
				.get(`getAnnouncementList`)
				.then((res) => {
					this.pub = res.data.data.pub;
					this.nPub = res.data.data.nPub;
				})
			},

			readMoreModal: function(obj){
				this.eventHub.$emit('openReadMoreModal', { stat: true,obj: obj });
			},

			dlAttacment: function(url,filename){
			  	//alert(filename)
			    axios({
			      url: url,
			      method: 'GET',
			      responseType: 'arraybuffer',
			    }).then((response) => {
			      var fileURL = window.URL.createObjectURL(new Blob([response.data]));
			      var fileLink = document.createElement('a');
			      fileLink.href = fileURL;
			      fileLink.setAttribute('download', filename);
			      document.body.appendChild(fileLink);

			      fileLink.click();
			    });
			},
		}
	};

</script>
